import type { ItemEditDirectoryOption, ItemEditOptions } from "../api";
import type { ReviewField } from "../views/ReviewQueue";

type References = Partial<Record<"location" | "assignee" | "trade" | "company", ItemEditDirectoryOption | null>>;

/** Company follows the assignee; trade remains independently editable. */
export function updateDirectoryFields(
  fields: ReviewField[], field: ReviewField, value: string,
  reference: ItemEditDirectoryOption | undefined,
  values: Record<string, string>, references: References, options?: ItemEditOptions | null,
): { values: Record<string, string>; references: References } {
  const nextValues = { ...values, [field.key]: value };
  const nextReferences = { ...references };
  if (field.reference) nextReferences[field.reference] = reference ?? null;
  if (field.reference === "assignee") {
    const companyField = fields.find((entry) => entry.reference === "company" && entry.calculated);
    if (companyField) {
      nextValues[companyField.key] = reference?.company ?? "";
      delete nextReferences.company;
    }
  }
  const fill = (kind: "company" | "trade", choice: ItemEditDirectoryOption) => {
    const target = fields.find((entry) => entry.reference === kind);
    if (!target) return;
    nextValues[target.key] = choice.name;
    nextReferences[kind] = choice;
  };
  if (reference?.remoteId && (field.reference === "assignee" || field.reference === "company")) {
    const matches = options?.trades.filter((trade) =>
      !!reference.tradeName && trade.name.trim().toLowerCase() === reference.tradeName.trim().toLowerCase());
    const trade = reference.tradeRemoteId && reference.tradeName
      ? { remoteId: reference.tradeRemoteId, name: reference.tradeName }
      : matches?.length === 1 ? matches[0] : undefined;
    if (trade) fill("trade", trade);
  }
  return { values: nextValues, references: nextReferences };
}
